import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import "./CopyToClipboard.scss";

const CopyToClipboard = ({ text }) => {
	const [copied, setCopied] = useState(false);

	const handleCopy = async (e) => {
		e.stopPropagation(); // prevent row click
		try {
			await navigator.clipboard.writeText(text);
			setCopied(true);
			setTimeout(() => setCopied(false), 1000);
		}
		catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	return (
		<div className="copy-button-container" onClick={handleCopy}>
			<button className="copy-button" title="Copy">
				<FontAwesomeIcon icon={copied ? faCheck : faCopy} />
				<span className="sr-only">{copied ? "Copied" : "Copy"}</span>
			</button>
		</div>
	);
};

export default CopyToClipboard;
